"use client";

import { CheckoutSteps } from "@features/checkoutSteps";
import { StickyContinueBarProvider } from "@features/checkout/context/stickyContinueBarContext";
import StickyContinueBar from "@features/checkout/components/stickyContinueBar";
import { joinClassNames } from "@utils/helpers";
import { AnimatePresence } from "framer-motion";
import { usePathname } from "next/navigation";

const STICKY_BAR_PATHS = [
  "/cart",
  "/cart/checkout/form",
  "/cart/checkout/payment",
];

export default function Layout({
  children,
  modal,
}: {
  children: React.ReactNode;
  modal: React.ReactNode;
}) {
  const pathname = usePathname();

  return (
    <StickyContinueBarProvider>
      <div
        className={joinClassNames(
          "relative flex flex-col gap-8 p-6 sm:pt-8 sm:pb-12 sm:px-12 bg-white rounded-2xl",
          STICKY_BAR_PATHS.includes(pathname) ? "mb-28 lg:mb-0" : ""
        )}
      >
        <CheckoutSteps />
        {children}
        <AnimatePresence>
          {pathname.includes("/cart/checkout/sign-in") && modal}
        </AnimatePresence>
        <StickyContinueBar />
      </div>
    </StickyContinueBarProvider>
  );
}
